import React, {Component} from 'react';
import './FancyPill.css';

class FancyPill extends Component {
	render() {
		const {items = []} = this.props;

		return (
			<div className="FancyPill">
				{items.map(item => (
					<button
						className={item.selected ? 'selected' : ''}
						key={item.title}
						onClick={item.selected ? undefined : item.onClick}
						title={item.title}
						disabled={item.disabled}>
						{item.text}
					</button>
				))}
			</div>
		);
	}
}

export default FancyPill;



// WEBPACK FOOTER //
// ./src/widgets/FancyPill.js